var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.975,
    height: 16,
    viewBox: "0 0 51.975 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1a1d76;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.313-36.068.671-20.566H4.9l2.644-15.5Z",
    transform: "translate(17.498 36.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-2.871-36.05-7.009-25.479l-.441-1.6A16.586,16.586,0,0,0-13.3-33.5l3.783,12.927,4.471-.008L1.605-36.054Z",
    transform: "translate(17.498 36.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-9.054-34.942a1.7,1.7,0,0,0-1.84-1.259h-6.55l-.054.309c5.1,1.237,8.469,4.216,9.869,7.8Z",
    transform: "translate(17.498 36.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.1-33.1a7.8,7.8,0,0,1,3.162.593l.381.18.572-3.36a10.906,10.906,0,0,0-3.785-.651c-4.174,0-7.117,2.1-7.14,5.116-.027,2.226,2.1,3.469,3.7,4.211,1.646.761,2.2,1.245,2.191,1.924-.013,1.037-1.313,1.513-2.527,1.513a8.872,8.872,0,0,1-3.978-.811l-.544-.248L7.54-21.16a13.356,13.356,0,0,0,4.707.826c4.441,0,7.327-2.077,7.357-5.3.019-1.761-1.108-3.1-3.55-4.208-1.478-.72-2.382-1.2-2.373-1.924C13.681-32.407,14.448-33.1,16.1-33.1Z",
    transform: "translate(17.498 36.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.059-36.051H27.8a2.1,2.1,0,0,0-2.214,1.286L19.309-20.559h4.436s.724-1.91.888-2.328l5.41.006c.126.541.515,2.322.515,2.322h3.919Zm-5.21,9.992c.347-.89,1.683-4.332,1.683-4.332-.023.042.344-.9.563-1.48l.284,1.336s.81,3.7.979,4.476Z",
    transform: "translate(17.498 36.334)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.16f1c169d4896ce0ef1b5daea5e958af.svg";
export { ForwardRef as ReactComponent };